// src/services/topBanner.api.js
import { apiRequest } from "./api";

export const getTopBannerMessages = () =>
  apiRequest("/top-banner");
